<template>
    <!-- qikan select -->

    <el-row type="flex" justify="center" align="top">
    <el-col :span="3" style="padding: 0 20px;margin:0">{{title}}：</el-col>
    <el-col :span="14" style="text-align: left;margin:0">
        <el-checkbox-group v-model="checkData" :max="items.lenght" @change="getList">
        <el-checkbox style="width: 130px; margin-bottom: 10px;" v-for="item in items" :label="item.id" :key="item.id"
        >{{item.name}}</el-checkbox>
        </el-checkbox-group>
    </el-col>
    </el-row>
</template>

<script>
import $C from "@/common/config.js"
export default {
  name: 'select-qikan',
  props:{
      title:{
          type:String,
          default:''
      },
      items:{
          type:Array,
          default:[]   //{id:1,data:'综合类'}
      },
      cate:{
          type:String,
          default:''
      }
  },
  data() {
      return {
          checkData:[],
      }
  },
  methods:{
      getList(v){
        //   console.log(v,this.cate)
          this.$emit("change",v,this.cate)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/select/Select.vue